
const propsWithoutStyleProp = function propsWithoutStyleProp(props) {
  const propsClone = Object.assign({}, props);
  delete propsClone.styles;
  return propsClone;
};

export default propsWithoutStyleProp;